// Importa o axios para requisições HTTP
import axios from 'axios';

// Importa a store de erro para tratamento de erros
import { useErroStore } from '@/stores/erroStore'

// Importa o componente do formulário de login
import { useLoginStore } from '@/stores/loginStore'

// Importa módulo que controla as autorizacoes se está logado ou não
import { useAuthStore } from '@/stores/authStore'

// Carrega o endereço da API
const API_BASE_URL = import.meta.env.VITE_API_URL;
const TEMPO_MONITORAMENTO = import.meta.env.VITE_TEMPO_MONITORAMENTO || 60000; // Padrão 1 minutos

// Serviço de Notificações
class NotificacaoService {

    // Construtor da classe de serviço
    constructor() {
        this.contadorAnterior = 0
        this.intervalId = null
        this.audio = null
    }

    // Iniciar o monitoramento periódico
    iniciarMonitoramento(callback) {

        // Parar monitoramento anterior se existir
        this.pararMonitoramento()
        
        // Iniciar verificação a cada 2 minutos
        this.intervalId = setInterval(async () => {
            await this.verificarChamados(callback)
        }, TEMPO_MONITORAMENTO)

        // Fazer uma verificação imediata ao iniciar
        this.verificarChamados(callback, true)
    }

    // Verificar chamados abertos
    async verificarChamados(callback, primeiraVerificacao = false) {

        try {

            // Cria variável que receberão os dados das autorizações de login
            var autorizacaoLogin = useAuthStore()

            // Se não estiver logado, sai da função
            if (autorizacaoLogin.estaLogado === false) {
                return;
            }

            const loginStore = useLoginStore()

            // Busca as quantidades de chamados abertos, orçamentos aprovados e comentarios novos
            const response = await axios.get(
                `${API_BASE_URL}/operacao/buscaChamadosSemNotificacao`, {
                    params: {
                        idColaborador: loginStore.idColaborador,
                        idEmpresa: loginStore.idEmpresa
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }                
                }
            );

            // Com axios, os dados já vêm em response.data
            const data = response.data
            
            // Verifica se existem chamados abertos, orçamentos aprovados ou comentários sem notificação
            if (data[0].length != 0 || 
                data[1].length != 0 || 
                data[2].length != 0 || 
                data[3].length != 0) {

                this.abertosAnteriores = data[0].length
                this.orcamentosAnteriores = data[1].length
                this.pendenteCliente = data[2].length
                this.comentariosAnteriores = data[3].length                

                // Executa callback para notificar a aplicação app.vue que existem novos chamados
                if (callback && typeof callback === 'function') {
                    callback(data[0], data[1], data[2], data[3])
                }
                
                // Tocar som de notificação
                this.tocarSomNotificacao()            
            }

        } catch (erro) {
            
            // Se não estiver testando o software e houver erro na api chama função para deslogar
            if(import.meta.env.VITE_TESTE_SOFT == 0){

                // Se houver erro na rotina, pede login novamente
                autorizacaoLogin.deslogar()
            }
        }
    }

    // Tocar som de notificação
    tocarSomNotificacao() {

        try {

            // Verificar se o navegador suporta AudioContext
            const AudioContext = window.AudioContext || window.webkitAudioContext
            
            if (!AudioContext) {
                console.warn('⚠️ AudioContext não suportado neste navegador')
                return
            }
            
            // Criar contexto de áudio
            const context = new AudioContext()
            
            // Criar oscilador para o som
            const oscillator = context.createOscillator()
            const gainNode = context.createGain()
            
            // Configurar oscilador
            oscillator.connect(gainNode)
            gainNode.connect(context.destination)
            
            // Som de sino/notificação (frequências mais agradáveis)
            oscillator.frequency.value = 800
            oscillator.type = 'sine'
            
            // Envelope de volume (sobe e desce suavemente)
            const now = context.currentTime
            gainNode.gain.setValueAtTime(0, now)
            gainNode.gain.linearRampToValueAtTime(0.3, now + 0.15)
            gainNode.gain.exponentialRampToValueAtTime(0.01, now + 1.0)
            
            // Tocar o som
            oscillator.start(now)
            oscillator.stop(now + 1.2)
            
        } catch (erro) {
            const erroStore = useErroStore()            
            erroStore.exibirErro(erro)
        }
    } 

    pararMonitoramento() {

        if (this.intervalId) {
            console.log('🛑 Monitoramento parado')
            clearInterval(this.intervalId)
            this.intervalId = null
        }
    }

    // Método para resetar o contador (quando usuário visualiza notificações)
    resetarContador() {
        
        this.contadorAnterior = 0
    }

    // Método para definir o contador manualmente
    definirContador(valor) {
        console.log(`🔢 Contador definido manualmente: ${valor}`)
        this.contadorAnterior = valor
    }

    // Método para verificar se o monitoramento está ativo
    estaMonitorando() {
        return this.intervalId !== null
    }
}

export default new NotificacaoService()